import React, { FunctionComponent } from "react";
import { styled } from "@mui/material/styles";
import Link from "@mui/material/Link";
import SubdirectoryArrowRight from "@mui/icons-material/SubdirectoryArrowRight";

import Banner from "./Banner";
import Text from "../text/Text";

const PREFIX = "BackBanner";

const classes = {
	icon: `${PREFIX}icon`,
};

const StyledBanner = styled(Banner)(({
	theme,
}) => ({
	[`& .${classes.icon}`]: {
		marginRight: 4,
		transform: "rotate(180deg)",
	},
}));

export interface BackBannerProps {
	/** browser url to return to */
	href: string;

	/** name of node to return to */
	name: string;
}

const BackBanner: FunctionComponent<BackBannerProps> = (props) => {
	const { href, name } = props;


	return (
		<StyledBanner height={38} px={4}>
			<Link href={href}>
				<SubdirectoryArrowRight className={classes.icon} />
				<Text res="BackTo" resParams={[name]} />
			</Link>
		</StyledBanner>
	);
};

export default BackBanner;